import { render } from "./showTipDialog.vue?vue&type=template&id=70bb99aa"
import script from "./showTipDialog.vue?vue&type=script&lang=js"
export * from "./showTipDialog.vue?vue&type=script&lang=js"

import "./showTipDialog.vue?vue&type=style&index=0&id=70bb99aa&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__